export default __webpack_public_path__ + "static/media/Opus Ignis.618fe89d.jpg";